<template>
    <div class="Rank">
       
            <div class="select_box">
                <div :style="{'border-bottom':'1px solid white'}">
                    <el-select v-model="value" placeholder="请选择" @change="changeVal" >
                        <el-option
                        v-for="item in RankArr"
                        :key="item.EventID"
                        :label="item.text"
                        :value="item.EventID">
                        </el-option>
                    </el-select>
                </div>
            </div>
        
        <div class="list_box">
            <ul class="list_ul">
                <li class="list_li" :style="{'color':'white','font-weight':'bold'}">
                    <div>排名</div>
                    <div>单位</div>
                    <div>姓名</div>
                </li>
            </ul>

            <ul :style="{'padding':'0 30px'}">
                <li class="lis list_li">
                    <div class="lis">
                        <i class="iconfont icon-jiangpai-guanjun-F ics" :style="{'color':'rgb(195,168,0)'}"></i>
                    </div>
                    <div class="lis">
                        <span>北京</span>
                    </div>
                    <div class="lis">
                        <span>李四</span>
                    </div>
                </li>
                <li class="lis list_li">
                    <div class="lis"><i class="iconfont icon-jiangpai-yajun-F ics" :style="{'color':'rgb(169,168,168)'}"></i></div>
                    <div class="lis">
                        <span>上海</span>
                    </div>
                    <div class="lis">
                        <span>张三</span>
                    </div>
                </li>
                <li class="lis list_li">
                    <div class="lis"><i class="iconfont icon-jiangpai-jijun-F ics" :style="{'color':'rgb(194,141,23)'}"></i></div>
                    <div class="lis">
                        <span>天津</span>
                    </div>
                    <div class="lis">
                        <span>王五</span>
                    </div>
                </li>
                <li class="lis list_li">
                    <div class="lis"><i class="iconfont icon-jiangpai-jijun-F ics" :style="{'color':'rgb(194,141,23)'}"></i></div>
                    <div class="lis">
                        <span>河北</span>
                    </div>
                    <div class="lis">
                        <span>勾留</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="annto">
            <div><i class="iconfont icon-jiangpai-guanjun-F ics" :style="{'color':'rgb(195,168,0)'}"></i>金牌</div>
            <div><i class="iconfont icon-jiangpai-yajun-F ics" :style="{'color':'rgb(169,168,168)'}"></i>银牌</div>
            <div><i class="iconfont icon-jiangpai-jijun-F ics" :style="{'color':'rgb(194,141,23)'}"></i>铜牌</div>
        </div>
    </div>
</template>

<script>
import mNav from "@/components/mNav.vue";
import http from '@/assets/js/http.js';
import RankList from '@/assets/common/RankList.json';
import {Loading} from 'element-ui';
export default {
    name: "Rank",
    components: {
        mNav,
    },
    data() {
        return {
            msg: sessionStorage.SportName,
            options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            value: '',
            Rank: [],
            activeNames:[],
            RankArr: [],
            list: [],
            loadingInstance: {},
            tableData: [{
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1517 弄'
            }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄'
            }]
        }
    },
    mounted() {
        // console.log(Rank)
        this.loadingInstance = Loading.service({
            lock: true,
            text: '正在加载,请稍后...',
        });
        http.GetFile('/Sports/BDM/BDM20240320/RankList.json?v='+Math.random()).then(res=>{//获取赛事列表地址
            this.loadingInstance.close();  // 关闭加载遮罩层
            console.log(res)
            this.Rank = res;
            this.haspolymerization();//数组聚合,重新整合json数据
        })
    },
    methods: {
        changeVal(value){
            // console.log(value)
            let arr = [];
            this.RankArr.forEach((el,index) => {
                if(value === el.EventID){
                    return arr = el.list;
                }
            });
            // console.log(arr);
            this.list = arr;
            this.activeNames = [];
        },
        haspolymerization(){//数组聚合,重新整合json数据
            let echararr = [];
            let data = this.Rank.JsonData;
            // console.log(data)
            /**
             * 将json数据按照日期先整合，重新生成新数组进行页面循环
            */
            data.forEach((el,index) => {
                // console.log(el)
                let arrindex = echararr.findIndex((item,index,arr)=>{
                    return item.text === el.EventName;
                })
                if(arrindex==-1){
                    echararr.push({
                        'text': el.EventName,
                        'EventID': el.EventID,
                        'ID': el.ID,
                        'list': [el],
                    })
                }else{
                    echararr[arrindex]['list'].push(el)
                }
            });
            
            // echararr.sort((a,b)=>{
            //     return new Date(a.date) - new Date(b.date);
            // })
            // echararr.sort()
            console.log(echararr);
            this.RankArr = echararr;
            this.value = echararr[0].EventID;
            this.list = echararr[0].list;
        },
    },
}
</script>

<style lang="scss" scoped>
    ::v-deep .van-collapse-item__title--disabled, .van-collapse-item__title--disabled .van-cell__right-icon{
        color: #333;
    }
    ::v-deep .el-input__inner{
        border-color:#3641C9;
        border: none;
        background: none;
        color: white;
        font-size: 20px;
        // text-align: center;
    }
    $bgColor: #3641C9;
    .yuan{
        display: inline-block;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid $bgColor;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        text-indent: 0;
    }
    .Rank{
        width: 93%;
        font-size: 20px;
        margin: 0 auto;
        margin-top: 10px;
        border-radius: 10px;
        background: white;
        box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.5);
        overflow: hidden;
        // background: $bgColor;
        // padding: 20px;
    }
    .ranktitle{
        padding: 0.3rem;
        font-weight: bold;
        font-size: 0.5rem;
        color: $bgColor;
    }
    .select_box{
        padding: 10px 30px;
        text-align: center;
        background: $bgColor;
    }
    .list_box{
        // padding: 0px 30px;
        min-height: 200px;
    }
    .lis{
        color: $bgColor;
        .ics{
            font-size: 30px;
            vertical-align: middle;
        }
        span{
            // margin-left: 10px;
        }
    }
    .annto{
        padding:15px 0;
        display: flex;
        font-size: 20px;
        justify-content: space-around;
        align-items: center;

        .ics{
            font-size: 30px;
            vertical-align: middle;
        }
        
    }
    .list_ul{
        background: $bgColor;
        padding: 0 30px;
    }
    .list_li{
        display: flex;
        line-height: 40px;
        border-bottom: 1px solid $bgColor;
        padding: 5px 0;
        div{
            flex: 1;
            text-align: center;
            
        }
    }
    
</style>